import axios from 'axios'
import DataObjs from './dataobjs'
import ScalablePlayer from '../scalableplayer'

var Util = DataObjs.Util

var STREAMING_TYPE = {
    HLS: 'hls',
    DASH: 'dash',
    PROGRESS: 'progressive',
    DOWNLOAD: 'download'
}

var SHARED_KEY = {
    QUALITY: 'quality',
    LAST_PLAY_ID: 'lastPlayID',
    LAST_GUID: 'lastGUID',
    AUTO_PLAY: 'autoPlay',
    PLAY_RATE: 'playRate',
    SCREEN_RATIO: 'screenRatio',
    UID_COOKIE: 'uidCookie',
    INIT_USER: 'initUser',
    TM_INFO: 'tmInfo',
    AUTO_PLAY_INFO: 'autoPlayInfo',
    I_WANT_FLASH: 'iWantFlash',
    PLAYER_TYPE: 'playerType',
    USER_NO: 'userNo',
    CREDENTIAL: 'credential'
}

export default class ApiManager {
    constructor () {
        this.baseUrl = 'https://apis.pooq.co.kr/'
        this.API_COMMAND = {
            // LOGIN: "login",
            STREAMING: 'streaming',
            // STREAMING_OTHER: "streaming/other",
            META_LIVE: 'live/channels/'
            /* META_VOD:"vod/contents/",
            META_BB_VOD: "dp/vod/contents/",
            META_BB_LIVE: "skb/baseball/stadiumconditionlist",
            META_MOVIE:"movie/contents/",
            META_CLIP:"clip/contents/",
            QVOD_CHECK: "streaming/status",
            POST_RECOMMENDATIONS: "cf/uiservice/recommend/contents/mostwith/",
            RELATED_CONTENT_LIST: "uiservice/recommend/contents/related/",
            RECOMMENDATIONS: "recommendation/contents",
            LIST_LIVE_POPULAR: "live/popular-channels",
            LIST_VOD_POPULAR: "vod/popularcontents",
            LIST_VOD_NEW:"vod/newcontents",
            LIST_VOD_PROGRAM:"vod/programs-contents/",
            LIST_VOD_RELATED:"vod/relatedcontents",
            LIST_MOVIE_RECOMMEND:"movie/recommend/contents",
            LIST_MOVIE_NEW:"movie/contents",
            HOME_SHOPPING: "homeshopping",
            GET_CONTENT_ID: "vod/programs-contentid/",
            GET_USER: "user",
            GET_USER_PIN_ADULT: "user/pin/adult" */
        }
    }

    isNull (item) {
        if (item === null || item === undefined) {
            return true
        }
        if (typeof item === typeof '' && item === '') {
            return true
        }
        return false
    }

    getPlayInfo (vodObject, dataInfo) {
        if (this.isNull(vodObject) || this.isNull(dataInfo)) {
            console.error('ApiManager-getPlayInfo: Invalid parameter')
            return null
        }

        let streamingUrl = this.baseUrl + this.API_COMMAND.STREAMING
        let contentType = vodObject.type
        let request = function () {
            let userInfo = dataInfo.getDefaultParam(contentType, vodObject.playerMode)
            userInfo.contentid = vodObject.contentID
            userInfo.contenttype = (!vodObject.isDVR) ? vodObject.type : 'timemachine'
            userInfo.action = STREAMING_TYPE.HLS
            /* if (metaObject.drms !== DRM_TYPE.NONE && metaObject.drms !== "") {
                userInfo.action = STREAMING_TYPE.DASH;
            } */
            userInfo.quality = vodObject.resolution
            userInfo.deviceModelId = Util.getOSInfoStr()
            userInfo.guid = dataInfo.GUID
            userInfo.lastplayid = dataInfo.getSetupValue(SHARED_KEY.LAST_PLAY_ID)
            userInfo.authtype = 'cookie'
            userInfo.isabr = 'y'
            userInfo.ishevc = 'n'

            let param = ''
            param += ('?device=' + userInfo.device)
            param += ('&partner=' + userInfo.partner)
            param += ('&pooqzone=' + userInfo.pooqzone)
            param += ('&region=' + userInfo.region)
            param += ('&drm=' + userInfo.drm)
            param += ('&targetage=' + userInfo.targetage)
            param += ('&apikey=' + userInfo.apikey)
            param += ('&credential=' + userInfo.credential)
            param += ('&contentid=' + userInfo.contentid)
            param += ('&contenttype=' + userInfo.contenttype)
            param += ('&action=' + userInfo.action)
            param += ('&quality=' + userInfo.quality)
            param += ('&deviceModelId=' + userInfo.deviceModelId)
            param += ('&guid=' + userInfo.guid)
            param += ('&lastplayid=' + userInfo.lastplayid)
            param += ('&authtype=' + userInfo.authtype)
            param += ('&isabr=' + userInfo.isabr)
            param += ('&ishevc=' + userInfo.ishevc)
            if (vodObject.playerMode === ScalablePlayer.playerMode.INSTANT) {
                param += ('&isinstant=y')
            }

            return axios({
                url: streamingUrl + param,
                body: userInfo,
                method: 'get',
                responseType: 'json'
            })
        }

        return request().then(function (res) {
            vodObject.setData(res.data)
            return vodObject
        }, null)
    }

    getMeta (vodType, contentID, metaObject, userInfo, mode) {
        if (this.isNull(vodType) || this.isNull(contentID) || this.isNull(metaObject) || this.isNull(userInfo)) {
            console.error('ApiManager-getMeta: Invalid parameter')
            return null
        }

        let baseUrl = this.baseUrl
        let apiCommand = this.API_COMMAND
        let request = function () {
            let extUrl = ''
            switch (vodType) {
                case ScalablePlayer.contentType.LIVE:
                    extUrl = apiCommand.META_LIVE
                    break
                case ScalablePlayer.contentType.VOD:
                case ScalablePlayer.contentType.QVOD:
                    extUrl = apiCommand.META_VOD
                    break
                case ScalablePlayer.contentType.MOVIE:
                    extUrl = apiCommand.META_MOVIE
                    break
            }

            let param = ''
            param += ('?device=' + userInfo.device)
            param += ('&partner=' + userInfo.partner)
            param += ('&pooqzone=' + userInfo.pooqzone)
            param += ('&region=' + userInfo.region)
            param += ('&drm=' + userInfo.drm)
            param += ('&targetage=' + userInfo.targetage)
            param += ('&apikey=' + userInfo.apikey)
            param += ('&credential=' + userInfo.credential)

            return axios({
                url: baseUrl + extUrl + contentID + param,
                method: 'get',
                responseType: 'json'
            })
        }

        return request().then(function (res) {
            metaObject.setData(res.data, vodType, mode)
            return metaObject
        }, null)
    }
}
